// extracted by mini-css-extract-plugin
module.exports = {"c1dkipv":"c1dkipv","n8pewtz":"n8pewtz","v3596o7":"v3596o7","t1ex5r5h":"t1ex5r5h"};